export const socketEvent = (event) => {
  return dispatch => {
    dispatch({
      type: "UPDATE_SOCKET_EVENT",
      socketEvent: event,
    })  
  }
}